import React from 'react';
import { Image, View } from 'react-native';
import Typography from '../Text/Text';
import { styles } from './InputError.styles';
import error from 'src/assets/error-3x.png';

interface InputErrorProps {
  errorText?: string;
  hintText?: string;
}

const InputError: React.FC<InputErrorProps> = ({ errorText, hintText }) => {
  const isHint = !!hintText;

  return (
    <View style={styles.container}>
      <Image
        source={error}
        style={[styles.icon, isHint && styles.hintIcon]} // Use different icon for hint if needed
      />
      <Typography
        variant="caption1Regular"
        style={isHint ? styles.hintText : styles.errorText} // Apply different styles for hint text
      >
        {isHint ? hintText : errorText}
      </Typography>
    </View>
  );
};

export default InputError;
